import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import HeaderModal from 'components/HeaderModal';
import TextField from '@mui/material/TextField';
import { Box, Grid, MenuItem, Paper, Typography } from '@mui/material';
import colorsSteps, { colors } from 'utils/colorsSteps';
import InputConsensus from 'components/InputConsensus';
import { Autocomplete } from '@mui/material';
import userService from 'services/user/userService';
import { useSelector } from 'react-redux';
import ButtonConsensus from 'components/ButtonConsensus';
import Moment from 'react-moment';
import { isInfraction } from 'utils/isInfraction';
import { toast } from 'react-toastify';
import SuggestInternalArchivingSection from './components/SuggestInternalArchivingSection';

const DISTRIBUTION_TYPE = {
  DIRECTED: 'directed',
  RANDOM: 'random',
};

const initialValues = {
  typeDistribution: '',
  prosecutor: null,
  prosecutorOffice: null,
  isService: false,
};

const ModalSelectDistributionType = props => {
  const {
    open,
    handleClose,
    title,
    inquiry,
    disbledConfirm,
    handleConfirm,
    onlyDistribution,
    inquiryClasse,
  } = props;

  const { selectedIndexGroup } = useSelector(state => state.groupMenu);
  const { groups } = useSelector(state => state.logedUser);

  const [formState, setFormState] = useState({ ...initialValues });
  const [prosecutors, setProsecutors] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [showAutocomplet, setShowAutocomplet] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [key, setKey] = useState(false);
  const [isInfractionAct, setIsInfractionAct] = useState(false);
  const [suggestArchiving, setSuggestArchiving] = useState(false);
  const [archivingJustification, setArchivingJustification] = useState('');
  const [archivingFile, setArchivingFile] = useState(null);

  const handleClickConfirm = () => {
    if (onlyDistribution) {
      const params =
        formState.typeDistribution === DISTRIBUTION_TYPE.RANDOM
          ? { isService: formState.isService }
          : {
              distributeToProsecutorId: formState.prosecutor?.id,
              prosecutorDesignation: formState.prosecutorOffice?.name,
              isService: formState.isService,
              justification: formState.justification,
            };

      if (suggestArchiving) {
        if (!archivingJustification.trim()) {
          return toast.warn('Informe a justificativa da sugestão de arquivento interno');
        }
        if (!archivingFile) {
          return toast.warn('Anexe o arquivo da sugestão de arquivamento interno');
        }
        params.suggestArchivingJustification = archivingJustification;
        params.suggestArchivingFile = archivingFile;
      }

      params.inquiryInvestigatedId = inquiry.id;

      handleConfirm(params);

      return;
    }
  };

  const getProsecutors = () => {
    const params = {
      prosecutorOfficeGroupIds:
        inquiry?.inquiry?.prosecutorOfficeGroup?.id ?? groups[selectedIndexGroup]?.id,
      onlyActiveProsecutor: true,
    };

    userService.getUsersProsecutorsService(params).then(response => {
      setProsecutors(response.data.data.sort((a, b) => a.name.localeCompare(b.name)));
      setShowAutocomplet(true);
    });
  };

  const handleChange = event => {

    setFormState(formState => ({
      ...formState,
      [event.target.name]:
        event.target.type === 'checkbox' ? event.target.checked : event.target.value,
    }));
  };

  const handleChangeProsecutor = (_, newValue) => {
    setFormState(formState => ({
      ...formState,
      prosecutor: newValue,
      prosecutorOffice: null,
    }));
    setKey(!key);
  };

  useEffect(() => {
    const { typeDistribution } = formState;
    if (typeDistribution !== '') {
      setShowBtn(true);
    }

    if (typeDistribution === DISTRIBUTION_TYPE.RANDOM) {
      setDisabled(false);
      setFormState(formState => ({
        ...formState,
        prosecutor: null,
        prosecutorOffice: null,
      }));
    }

    if (typeDistribution === DISTRIBUTION_TYPE.DIRECTED) {
      getProsecutors();
    }
  }, [formState.typeDistribution]);

  useEffect(() => {
    const { typeDistribution, prosecutor, prosecutorOffice, justification } = formState;
    if (typeDistribution === DISTRIBUTION_TYPE.DIRECTED) {
      if (prosecutor && prosecutorOffice && justification?.trim()) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [
    formState.typeDistribution,
    formState.prosecutor,
    formState.prosecutorOffice,
    formState.justification,
  ]);

  useEffect(() => {
    if (isInfraction(inquiryClasse)) {
      setIsInfractionAct(true);
    }
  }, []);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <HeaderModal onClose={handleClose}>{title}</HeaderModal>
      <DialogContent>
        <Paper
          elevation={2}
          style={{
            width: '100%',
            padding: 8,
            background: colorsSteps.PESQUISA_DISTRIBUICAO,
          }}
        >
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography variant="h5" style={{ color: '#fff' }}>
              Ao prosseguir a supercertidão será enviada/salva.
            </Typography>
            <Typography variant="h5" style={{ color: '#fff' }}>
              Caso precise revisar algum item, feche esta janela.
            </Typography>
          </Box>
        </Paper>

        <Box mt={2} display="flex" justifyContent="center">
          <Typography variant="h5">A distribuição deve ser específica ou aleatória?</Typography>
        </Box>

        <Box my={2}>
          <Grid container spacing={2}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <InputConsensus
                label="Distribuição"
                name="typeDistribution"
                onChange={handleChange}
                value={formState.typeDistribution || ''}
                select
                fullWidth
              >
                <MenuItem value={DISTRIBUTION_TYPE.DIRECTED}>Específica</MenuItem>
                <MenuItem value={DISTRIBUTION_TYPE.RANDOM}>Aleatória</MenuItem>
              </InputConsensus>
            </Grid>
            {formState.typeDistribution === DISTRIBUTION_TYPE.RANDOM && (
              <SuggestInternalArchivingSection
                suggestArchiving={suggestArchiving}
                archivingJustification={archivingJustification}
                archivingFile={archivingFile}
                onSuggestArchivingChange={setSuggestArchiving}
                onArchivingJustificationChange={setArchivingJustification}
                onArchivingFileChange={setArchivingFile}
              />
            )}
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              {showAutocomplet && formState.typeDistribution !== DISTRIBUTION_TYPE.RANDOM && (
                <Autocomplete
                  options={prosecutors}
                  fullWidth
                  autoHighlight
                  onChange={handleChangeProsecutor}
                  key={key}
                  noOptionsText="Não encontrado"
                  value={formState.prosecutor}
                  getOptionLabel={option => option.name || ''}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <div>{option.name}</div>
                    </li>
                  )}
                  renderInput={params => (
                    <InputConsensus
                      {...params}
                      name="name"
                      label="Promotor"
                      variant="standard"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              )}
            </Grid>
            {formState.prosecutor && (
              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <InputConsensus
                  select
                  label="Promotoria"
                  name="prosecutorOffice"
                  value={formState.prosecutorOffice || ''}
                  onChange={handleChange}
                  variant="standard"
                  size="small"
                  fullWidth
                >
                  {formState.prosecutor.designations.map(office => {
                    const prosecutorOfficeGroupId = inquiry.inquiry.prosecutorOfficeGroup.id;
                    const blocking = office?.blockings?.find(
                      blocking => blocking.prosecutorOfficeGroup.id === prosecutorOfficeGroupId,
                    );
                    return (
                      <MenuItem key={office.name} value={office} disabled={!!blocking}>
                        {blocking ? (
                          blocking?.startDate && blocking?.endDate ? (
                            <Box>
                              <span>Inativo no período: </span>
                              <Moment format="DD/MM/YYYY">{blocking.startDate}</Moment>
                              <span> até </span>
                              <Moment format="DD/MM/YYYY">{blocking.endDate}</Moment>
                              <Box>{office.name}</Box>
                            </Box>
                          ) : (
                            <Box>
                              <Box>Promotor Inativo</Box>
                              <Box>{office.name}</Box>
                            </Box>
                          )
                        ) : (
                          office.name
                        )}
                      </MenuItem>
                    );
                  })}
                </InputConsensus>
              </Grid>
            )}
            {formState.prosecutor && (
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  multiline
                  variant="outlined"
                  fullWidth
                  minRows={6}
                  maxRows={10}
                  label="Justificativa"
                  name="justification"
                  value={formState.justification}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            )}
            {formState.prosecutor && (
              <SuggestInternalArchivingSection
                suggestArchiving={suggestArchiving}
                archivingJustification={archivingJustification}
                archivingFile={archivingFile}
                onSuggestArchivingChange={setSuggestArchiving}
                onArchivingJustificationChange={setArchivingJustification}
                onArchivingFileChange={setArchivingFile}
              />
            )}
            {isInfractionAct && (
              <Grid size={12}>
                <Box display="flex" alignItems="center">
                  <input
                    type="checkbox"
                    name="isService"
                    checked={formState.isService}
                    onChange={handleChange}
                  />
                  <Typography style={{ marginLeft: '8px' }}>Atendimento</Typography>
                </Box>
              </Grid>
            )}
            {showBtn && (
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Box display="flex" justifyContent="flex-end">
                  <ButtonConsensus
                    title="Cancelar"
                    backgroundColor="#fff"
                    hovercolor={colors.greySecundary}
                    color={colors.greyShadow}
                    onClick={handleClose}
                  />
                  <ButtonConsensus
                    title="Confirmar"
                    backgroundColor={colors.primary}
                    hovercolor={colors.primary}
                    color={colors.greShadow}
                    onClick={handleClickConfirm}
                    disabled={disabled || disbledConfirm}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalSelectDistributionType;
